// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JUowlo_EKQ6qpj {
  display: inline-flex;
  height: 32px;
  margin: var(--ds-space-0, 0);
  float: left;
  line-height: 32px;
  white-space: nowrap;
}
.wTL1XivAFqmK4O {
  display: flex;
}
.wTL1XivAFqmK4O > div:last-child {
  flex-shrink: 0;
}
.QyEx6cNKKLlbSu {
  background-color: var(--dynamic-button);
  color: var(--dynamic-text);
  position: relative;
  flex-shrink: 0;
  min-width: 32px;
  max-width: 400px;
  height: 32px;
  margin: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
  float: left;
  overflow: hidden;
  border-radius: var(--ds-border-radius-100, 3px);
  font-size: 14px;
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 32px;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.QyEx6cNKKLlbSu svg circle {
  stroke: var(--dynamic-icon);
}
.QyEx6cNKKLlbSu.G8AvVbmOenslDQ .waCSqymiEHKJxl {
  margin-right: var(--ds-space-0, 0);
}
.QyEx6cNKKLlbSu.yhuDH_QTIBwFSN {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.QyEx6cNKKLlbSu.yhuDH_QTIBwFSN svg circle {
  stroke: var(--dynamic-icon);
}
.QyEx6cNKKLlbSu.yhuDH_QTIBwFSN:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.QyEx6cNKKLlbSu:hover {
  background-color: var(--dynamic-button-hovered);
  color: var(--dynamic-text);
  text-decoration: none;
}
.QyEx6cNKKLlbSu:hover svg circle {
  stroke: var(--dynamic-icon);
}
.QyEx6cNKKLlbSu:active {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-pressed);
  color: var(--dynamic-button-pressed-text);
}
.QyEx6cNKKLlbSu:active svg circle {
  stroke: var(--dynamic-icon);
}
@media only screen and (max-width: 900px) {
  .QyEx6cNKKLlbSu {
    color: var(--dynamic-text);
    position: relative;
    flex-shrink: 0;
    min-width: 32px;
    max-width: 400px;
    height: 32px;
    margin: var(--ds-space-0, 0) var(--ds-space-075, 5px) var(--ds-space-050, 4px) var(--ds-space-0, 0);
    padding: var(--ds-space-0, 0) var(--ds-space-150, 12px) var(--ds-space-0, 0) var(--ds-space-150, 12px);
    float: left;
    overflow: hidden;
    border-radius: var(--ds-border-radius-100, 3px);
    font-size: 14px;
    line-height: 32px;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
  }
  .QyEx6cNKKLlbSu svg circle {
    stroke: var(--dynamic-icon);
  }
  .QyEx6cNKKLlbSu:hover {
    background-color: var(--dynamic-button-hovered);
    color: var(--dynamic-text);
    text-decoration: none;
  }
  .QyEx6cNKKLlbSu:hover svg circle {
    stroke: var(--dynamic-icon);
  }
}
.G8AvVbmOenslDQ {
  min-width: 16px;
  text-overflow: unset;
}
.G8AvVbmOenslDQ .o_XEc8GtywN0Ha {
  display: none;
}
.csDjZbiwtFpe2C {
  min-width: 32px;
  height: 32px;
  padding: var(--ds-space-075, 6px);
}
.csDjZbiwtFpe2C .GaUYHBzbUaL2aj {
  margin-left: var(--ds-space-0, 0);
}
.csDjZbiwtFpe2C.yhuDH_QTIBwFSN {
  color: var(--dynamic-text);
  background-color: var(--dynamic-button-highlighted);
  color: var(--dynamic-button-highlighted-text);
}
.csDjZbiwtFpe2C.yhuDH_QTIBwFSN svg circle {
  stroke: var(--dynamic-icon);
}
.csDjZbiwtFpe2C.yhuDH_QTIBwFSN:hover {
  background: var(--dynamic-button-highlighted-hovered);
  color: var(--dynamic-button-highlighted-text);
}
.p9ogagSSTohJmd {
  min-width: 54px;
}
.waCSqymiEHKJxl {
  width: 20px;
  margin-right: var(--ds-space-075, 6px);
}
.KGY44nfoL0zNMC {
  position: absolute;
  z-index: -1;
  width: 32px;
  height: 32px;
}
.R37lMBLIrm13th h1 {
  font-size: 16px;
  line-height: 20px;
}
.R37lMBLIrm13th p {
  font-size: 14px;
  line-height: 20px;
}
.S4hu9jp03mWBrp {
  margin-right: var(--ds-space-100, 8px);
}
@media only screen and (min-width: 1281px) {
  .S4hu9jp03mWBrp {
    display: none;
  }
}
@media only screen and (max-width: 1280px) {
  .DkFidScGfBEG6X {
    display: none;
  }
}
.J1HFe3oIoRy0Xy {
  margin-bottom: var(--ds-space-150, 12px);
}
`, ""]);
// Exports
export var viewSwitcherContainer = `JUowlo_EKQ6qpj`;
export var switcherButtonsContainer = `wTL1XivAFqmK4O`;
export var viewSwitcherButton = `QyEx6cNKKLlbSu`;
export var collapsed = `G8AvVbmOenslDQ`;
export var viewSwitcherIcon = `waCSqymiEHKJxl`;
export var highlighted = `yhuDH_QTIBwFSN`;
export var buttonText = `o_XEc8GtywN0Ha`;
export var overflowButton = `csDjZbiwtFpe2C`;
export var downIcon = `GaUYHBzbUaL2aj`;
export var overflowButtonLarge = `p9ogagSSTohJmd`;
export var dummyPopoverTarget = `KGY44nfoL0zNMC`;
export var spotlight = `R37lMBLIrm13th`;
export var hideOnNormalScreens = `S4hu9jp03mWBrp`;
export var showOnNormalScreens = `DkFidScGfBEG6X`;
export var premiumBanner = `J1HFe3oIoRy0Xy`;
export default ___CSS_LOADER_EXPORT___;
